import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useFieldAttributes } from "../../../services/field-attributes.js";
import { getDatePartsErrors } from "../../../ui/date-field/date-field-utils.js";
import { FieldDescriptionWUT } from "../../../ui/field-description/field-description-wut.js";
import { FieldErrorWUT } from "../../../ui/field-error/field-error-wut.js";
import { FieldLabelWUT } from "../../../ui/field-label/field-label-wut.js";
import { Widget } from "../../../ui/widget/widget.js";
import { DateFieldWUT } from "../../../ui/date-field/date-field-wut.js";
const DateInputWUT = ({
  id,
  description,
  target,
  value,
  error,
  hasError = false,
  errorMessage,
  required,
  label,
  hideLabel,
  onBlur,
  onFocus,
  onChange,
  disabled,
  hidePlaceholder,
  showDateLabels,
  requiredIndicatorType,
  requiredIndicatorPlacement,
  FieldLayout,
  widgetHtml,
  widgetEnabled
}) => {
  const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
  return /* @__PURE__ */ jsx(
    FieldLayout,
    {
      fieldId: id,
      renderLabel: () => /* @__PURE__ */ jsx(
        FieldLabelWUT,
        {
          labelId,
          required,
          label,
          hideLabel,
          requiredIndicatorType,
          requiredIndicatorPlacement
        }
      ),
      renderInput: () => widgetHtml && widgetEnabled ? /* @__PURE__ */ jsx(
        Widget,
        {
          fieldId: id,
          widgetHtml,
          onChange,
          value
        }
      ) : /* @__PURE__ */ jsx(
        DateFieldWUT,
        {
          onBlur,
          onChange,
          onFocus,
          inputId,
          ariaLabelledBy: labelId,
          value: value ?? "",
          id,
          disabled,
          errors: getDatePartsErrors(hasError, value ?? ""),
          hidePlaceholder,
          showDateLabels,
          required,
          ariaDescribedBy
        }
      ),
      renderDescription: () => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          FieldErrorWUT,
          {
            target,
            hasError,
            errorMessage,
            id: errorId
          }
        ),
        /* @__PURE__ */ jsx(FieldDescriptionWUT, { description, id: descriptionId })
      ] })
    }
  );
};
export {
  DateInputWUT
};
//# sourceMappingURL=date-input-wut.js.map
